import { render, staticRenderFns } from "./DownloadCSVButton.vue?vue&type=template&id=5203a412"
import script from "./DownloadCSVButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./DownloadCSVButton.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports